import React from "react";
import { Box, Typography, Stack } from "@mui/material";

export const DATA_CATEGORY_TAGS = {
  PHONE: "phone_number",
  EMAIL: "personal_email",
  ADDRESS: "home_address",
  EMPLOYMENT: "employment_history",
  SSN: "social_security",
  FAMILY: "family_relationships",
};

export const CATEGORY_LABELS = {
  phone_number: "Mobile Phone",
  personal_email: "Personal Email",
  home_address: "Home Address",
  employment_history: "Employment History",
  social_security: "Social Security",
  family_relationships: "Family Relationships",
};

export const T = {
  bg: "#F7F8FC",
  surface: "#FFFFFF",
  border: "#E2E8F0",
  ink: "#0F172A",
  muted: "#64748B",
  faint: "#94A3B8",
  accent: "#09b2f0",
  accentDark: "#07a0d9",
  accentBg: "#F0F9FF",
};

export const STATUS_CONFIG = {
  data_deleted: { dot: "#22C55E", label: "Data Deleted" },
  request_in_progress: { dot: "#F97316", label: "In Progress" },
  request_sent: { dot: "#3B82F6", label: "Request Sent" },
  "Data Deleted": { dot: "#22C55E", label: "Data Deleted" },
  "In Progress": { dot: "#F97316", label: "In Progress" },
  "Request Sent": { dot: "#3B82F6", label: "Request Sent" },
};

export function relativeDate(dateStr) {
  if (!dateStr) return "—";
  const now = new Date();
  const then = new Date(dateStr);
  const nowDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const thenDay = new Date(then.getFullYear(), then.getMonth(), then.getDate());
  const diffDays = Math.round((nowDay - thenDay) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 30) return `${diffDays} days ago`;
  const diffMonths = Math.round(diffDays / 30.44);
  if (diffMonths === 1) return "1 month ago";
  if (diffMonths < 12) return `${diffMonths} months ago`;
  const diffYears = Math.round(diffDays / 365.25);
  return diffYears === 1 ? "1 year ago" : `${diffYears} years ago`;
}

/* ─── SVG Icons ─── */

export function SendIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M22 2L11 13" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export function RadarIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="black" strokeWidth="2" />
      <path d="M12 7v5l3 3" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ShieldCheckIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="black" strokeWidth="2.5" strokeDasharray="48 8" strokeLinecap="round" />
      <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="black" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function PhoneIcon({ size = 18, color = "#6B7280" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="6" y="3" width="12" height="18" rx="2" stroke={color} strokeWidth="2" />
      <path d="M12 18h.01" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function EmailIcon({ size = 18, color = "#6B7280" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="5" width="18" height="14" rx="2" stroke={color} strokeWidth="2" />
      <path d="M3 7l9 6 9-6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function HomeIcon({ size = 18, color = "#6B7280" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M3 10l9-7 9 7v10a2 2 0 01-2 2H5a2 2 0 01-2-2V10z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 21V12h6v9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function BriefcaseIcon({ size = 18, color = "#6B7280" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="7" width="18" height="13" rx="2" stroke={color} strokeWidth="2" />
      <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" stroke={color} strokeWidth="2" />
      <path d="M3 13h18" stroke={color} strokeWidth="2" />
    </svg>
  );
}

function ShieldIcon({ size = 18, color = "#6B7280" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6l-8-4z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 12l2 2 4-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function UsersIcon({ size = 18, color = "#6B7280" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="7" r="4" stroke={color} strokeWidth="2" />
      <path d="M2 21v-2a4 4 0 014-4h6a4 4 0 014 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <circle cx="17" cy="7" r="3" stroke={color} strokeWidth="2" />
      <path d="M23 21v-2a3 3 0 00-3-3" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function CategoryIcon({ tag, size = 18 }) {
  const color = "#9CA3AF";
  if (tag === DATA_CATEGORY_TAGS.PHONE) return <PhoneIcon size={size} color={color} />;
  if (tag === DATA_CATEGORY_TAGS.EMAIL) return <EmailIcon size={size} color={color} />;
  if (tag === DATA_CATEGORY_TAGS.ADDRESS) return <HomeIcon size={size} color={color} />;
  if (tag === DATA_CATEGORY_TAGS.EMPLOYMENT) return <BriefcaseIcon size={size} color={color} />;
  if (tag === DATA_CATEGORY_TAGS.SSN) return <ShieldIcon size={size} color={color} />;
  if (tag === DATA_CATEGORY_TAGS.FAMILY) return <UsersIcon size={size} color={color} />;
  return <div style={{ width: size, height: size, borderRadius: "50%", background: color }} />;
}

/* ─── Shared UI primitives ─── */

export function Card({ children, sx = {} }) {
  return (
    <Box
      sx={{
        bgcolor: T.surface,
        border: "1px solid #E2E8F0",
        borderRadius: "16px",
        boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
        overflow: "hidden",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export function SectionTitle({ title, subtitle, action }) {
  return (
    <Box
      sx={{
        px: 2.5,
        py: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #F1F5F9",
        backgroundColor: "#FAFBFD",
      }}
    >
      <Box>
        <Typography variant="subtitle1" sx={{ fontSize: "1rem", fontWeight: 700, color: T.ink, lineHeight: 1.3 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ fontSize: "0.78rem", color: T.faint, mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && <Box>{action}</Box>}
    </Box>
  );
}

export function ActionButton({ label, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        px: 1.5,
        py: 0.75,
        bgcolor: "#f59e0b",
        borderRadius: 2,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        transition: "opacity 0.15s",
        flexShrink: 0,
        "&:hover": { opacity: 0.85 },
      }}
    >
      <Typography sx={{ fontSize: "0.78rem", fontWeight: 700, color: "#000", whiteSpace: "nowrap" }}>
        {label} →
      </Typography>
    </Box>
  );
}

export function MetricCard({ title, value, sub, icon }) {
  return (
    <Box
      sx={{
        bgcolor: T.surface,
        border: `1px solid ${T.border}`,
        borderRadius: 2,
        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
        p: 2,
        height: "100%",
        boxSizing: "border-box",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
        <Box sx={{ bgcolor: "#F9FAFB", borderRadius: 1, p: 0.75, display: "flex", alignItems: "center" }}>
          {icon}
        </Box>
        <Typography variant="caption" sx={{ fontSize: "0.7rem", fontWeight: 700, color: T.faint, letterSpacing: "0.08em", textTransform: "uppercase", textAlign: "right" }}>
          {title}
        </Typography>
      </Stack>
      <Typography sx={{ fontSize: "2.2rem", fontWeight: 800, color: T.ink, lineHeight: 1, letterSpacing: "-1.5px" }}>
        {value}
      </Typography>
      <Typography variant="caption" sx={{ fontSize: "0.75rem", color: T.faint, mt: 0.75, display: "block" }}>
        {sub}
      </Typography>
    </Box>
  );
}

export function StatusBadge({ status }) {
  const c = STATUS_CONFIG[status] ?? STATUS_CONFIG.request_sent;
  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ px: 1, py: 0.4, borderRadius: 10, display: "inline-flex", flexShrink: 0 }}>
      <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: c.dot, flexShrink: 0 }} />
      <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: T.muted, whiteSpace: "nowrap" }}>
        {c.label}
      </Typography>
    </Stack>
  );
}
